import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SoulAnalysis from "@/pages/SoulAnalysis";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <div className="starfield" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SoulAnalysis />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
